import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StorePerformanceInterval } from '../../../../../../constants';
import { HelpASaleItem } from '../../../../../../hooks';
import { ColumnFlexContainer, RowFlexContainer } from '../../../../../../stories/atoms/containerV2/ContainerV2';
import { homeTranslations } from '../../../../../../translations';
import { formatAmountWithSeparator } from '../../../../../../utils';
import { WidgetMetricTile, WidgetMetricType } from '../../../../common/metricTile/WidgetMetricTile';
import WidgetChart from '../../../../common/widgetChart/WidgetChart';

type HelpASaleGraphProps = {
  uplift: number;
  interval: StorePerformanceInterval;
  hasSalesItems: HelpASaleItem[];
  filteredPerformanceItems: (HelpASaleItem | null)[];
};

const itemValueResolver = (item: HelpASaleItem) => {
  const { helpASaleSales, nonHelpASaleSales } = item;
  return nonHelpASaleSales === 0 ? 0 : (helpASaleSales / nonHelpASaleSales) * 100;
};

export const HelpASaleGraph: FC<HelpASaleGraphProps> = ({
  uplift,
  interval,
  hasSalesItems,
  filteredPerformanceItems,
}) => {
  const { t } = useTranslation();
  const { helpASale: helpASaleTranslations } = homeTranslations;

  return (
    <ColumnFlexContainer
      data-testid="help-a-sale-widget-graph-wrapper"
      padding={[4]}
      height="100%"
      flex={1}
      overflow="hidden"
    >
      <RowFlexContainer>
        <WidgetMetricTile
          metricProperties={{
            type: WidgetMetricType.LegendMetric,
            properties: {
              metricTitle: t(helpASaleTranslations.upliftText.key, helpASaleTranslations.upliftText.defaultValue),
              metricValue: formatAmountWithSeparator(uplift, '%'),
              legendColor: 'validationGreen',
              metricTooltipText: t(
                helpASaleTranslations.upliftTooltipText.key,
                helpASaleTranslations.upliftTooltipText.defaultValue,
              ),
            },
          }}
        />
      </RowFlexContainer>
      <ColumnFlexContainer flex={1} minHeight={'0'}>
        <WidgetChart
          performanceItemsChartName={t(
            helpASaleTranslations.upliftText.key,
            helpASaleTranslations.upliftText.defaultValue,
          )}
          performanceItems={hasSalesItems}
          filteredPerformanceItems={filteredPerformanceItems}
          forecastPerformanceItems={[]}
          interval={interval}
          itemValueResolver={itemValueResolver}
          showXAxis={true}
          yAxisFormatter={(value) => `${value.toFixed(1)}%`}
          tooltipFormatter={(value) => `${value.toFixed(2)}%`}
          yAxisMin={0}
        />
      </ColumnFlexContainer>
    </ColumnFlexContainer>
  );
};
